/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseControl from './BaseControl.vue';

const __vue_script__ = {
    name: 'MultiFactorCodeControl',

    extends: BaseControl,

    props: {
        errors: {
            type: Array,
            default: () => []
        },

        value: {
            type: [String],
            default: null
        },

        label: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            internalValue: Array(6),
            errorsToShow: this.errors
        };
    },

    watch: {
        errors(newErrors) {
            this.errorsToShow = newErrors;
        },

        value(newValue) {
            const valueArray = Array.from(newValue || '');
            this.internalValue = Array.from(Array(6)).map((_, i) => valueArray[i] || null);
        }
    },

    methods: {
        dataChange(index) {
            this.errorsToShow = [];

            if (this.internalValue[index] && index + 1 < this.internalValue.length) {
                this.$nextTick(() => {
                    this.$refs.digit[index + 1].focus();
                });
            }
            // can't use every as every skips empty slot
            for (const digit of this.internalValue) {
                if (!/\d/.test(digit)) {
                    return;
                }
            }
            this.$emit('input', this.internalValue.join(''));
        },

        handleSpecialKeys(index, event) {
            if (event.key === 'Backspace' && !this.internalValue[index] && index > 0) {
                this.internalValue[index - 1] = '';
                this.$nextTick(() => {
                    this.$refs.digit[index - 1].focus();
                });
            }
            if (event.key === 'ArrowRight' && index + 1 < this.internalValue.length) {
                this.$nextTick(() => {
                    this.$refs.digit[index + 1].focus();
                });
            }
            if (event.key === 'ArrowLeft' && index > 0) {
                this.$nextTick(() => {
                    this.$refs.digit[index - 1].focus();
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"multi-factor-code-control form-group",attrs:{"dependant":_vm.dependant,"label":_vm.label,"errors":_vm.errorsToShow,"warning":_vm.warning,"hint-after-label":_vm.hintAfterLabel,"uid":_vm.uid},scopedSlots:_vm._u([{key:"after-label",fn:function(ref){return [_vm._t("after-label")]}},{key:"inside-label",fn:function(ref){return [_vm._t("inside-label")]}}],null,true)},_vm._l((_vm.internalValue),function(digit,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue[index]),expression:"internalValue[index]"}],ref:"digit",refInFor:true,staticClass:"form-control",class:{'has-error':  _vm.errorsToShow.length },attrs:{"type":"text","inputmode":"numeric","pattern":"[0-9]","maxlength":"1","placeholder":"_","required":"required","name":(_vm.name + "[" + index + "]")},domProps:{"value":(_vm.internalValue[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.internalValue, index, $event.target.value)},function($event){return _vm.dataChange(index)}],"keydown":function (event) { return _vm.handleSpecialKeys(index, event); }}})}),0)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MultiFactorCodeControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__